const { InnerBlocks } = wp.blockEditor;

export default function Edit() {
  return (
    <div className="TabSumicity__content">
      <div>
        <h3>Selecione Abaixo os blocos desejados</h3>
        <p>
          Alterne entre as guias para escolher os respectivos blocos de cada
          guia
        </p>
      </div>
      <InnerBlocks />
    </div>
  );
}
